var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"fill":"#5CB85C","d":"M47.2.5a46.6 46.6 0 100 93.2 46.6 46.6 0 000-93.2zm-6.7 65.2L23.9 49l5.2-5.2L40.5 55l24.7-24.7 5.3 5.3-30 30z","key":1})]);
}

Checkmark.defaultProps = {"fill":"none","viewBox":"0 0 94 94"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
